module.exports = __webpack_public_path__ + "static/media/brand-white.469154d2.png";